import { render, staticRenderFns } from "./xd-phone-input.vue?vue&type=template&id=7c92c94f&scoped=true&"
import script from "./xd-phone-input.vue?vue&type=script&lang=js&"
export * from "./xd-phone-input.vue?vue&type=script&lang=js&"
import style0 from "./xd-phone-input.vue?vue&type=style&index=0&id=7c92c94f&lang=scss&scoped=true&"
import style1 from "./xd-phone-input.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c92c94f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Admin\\Documents\\moonjerx\\starguar\\code\\web-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c92c94f')) {
      api.createRecord('7c92c94f', component.options)
    } else {
      api.reload('7c92c94f', component.options)
    }
    module.hot.accept("./xd-phone-input.vue?vue&type=template&id=7c92c94f&scoped=true&", function () {
      api.rerender('7c92c94f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/xd-phone-input/xd-phone-input.vue"
export default component.exports